import { Component, ElementRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { getDisplayStyleByFieldId } from 'src/app/shared/functions/helpers/display-style-helpers';
import { ConditionalBgTagComponent } from "../../../ui/conditional-bg-tag/conditional-bg-tag.component";
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';
import { TruncatePipe } from 'src/app/shared/pipes/truncate/truncate.pipe';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';

const HIDE_POPUP_DELAY_TIME = 100; //ms
@Component({
  selector: 'bizz-grid-cell-text',
  templateUrl: './grid-cell-text.component.html',
  styleUrls: ['./grid-cell-text.component.scss'],
  standalone: true,
  imports: [ConditionalBgTagComponent, TruncatePipe, IconComponent]
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridCellTextComponent extends GridCellBaseComponent<string> implements OnInit {
  @ViewChild('anchor', { read: ElementRef })
  public anchorEl: ElementRef;
  @ViewChild('readmorePopupTemplateRef', { static: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readmorePopupTemplateRef: TemplateRef<any>;
  private readmorePopup: PopupRef | null = null;

  private popupService = inject(PopupService)

  public showReadMoreIcon: boolean = false;
  private anchorHovered = false;
  private popupHovered = false;
  public backgroundColor: string;
  public foregroundColor: string;
  public columnHasDisplayStyle = false;

  protected override onDataChanged(): void {
    this.columnHasDisplayStyle = this.column.DisplayStyleValues && 
    this.column.DisplayStyleValues.length > 0;
    const idProperty = this.column.field + '_ID';
    if(this.column.DisplayStyleValues && 
      idProperty in this.data &&
      this.data[idProperty]) {
          const id = Number(this.data[idProperty]);
          const displayValue = getDisplayStyleByFieldId(this.column.DisplayStyleValues, id);
          if(displayValue) {
            this.backgroundColor = displayValue.BackgroundColor;
            this.foregroundColor = displayValue.ForegroundColor;
            this.columnHasDisplayStyle = true;
          } else {
            this.backgroundColor = '';
            this.foregroundColor = '';
          }
      }

    if(this.data['ShowReadMoreIconFor' + this.column.field]){
      this.showReadMoreIcon = this.data['ShowReadMoreIconFor' + this.column.field] as unknown as boolean;
    }
    else if(this.column.ShowReadMoreIcon)
      this.showReadMoreIcon = true;

    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public ngOnInit(): void {
    if(this.data['ShowReadMoreIconFor' + this.column.field]){
      this.showReadMoreIcon = this.data['ShowReadMoreIconFor' + this.column.field] as unknown as boolean;
    }
    else if(this.column.ShowReadMoreIcon)
      this.showReadMoreIcon = true;
  }

  public onAnchorMouseEnter(): void {
    this.anchorHovered = true;
    this.showPopup();
  }

  public onAnchorMouseLeave(): void {
    this.anchorHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public onPopupMouseEnter(): void {
    this.popupHovered = true;
    this.showPopup();
  }

  public onPopupMouseLeave(): void {
    this.popupHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public showPopup(): void {
    if (this.readmorePopup != null) return;

    this.readmorePopup = this.popupService.open({
      anchor: this.anchorEl,
      content: this.readmorePopupTemplateRef,
      popupClass:
        'w-svw h-svh sm:w-fit sm:h-auto sm:min-w-[400px] sm:-mt-[0.5rem] sm:rounded-md maxw-sm:!top-0 !z-[9999] maxw-sm:!left-0 maxw-sm:!right-0',
      animate: false,
      anchorAlign: { horizontal: 'center', vertical: 'bottom' },
      popupAlign: { horizontal: 'center', vertical: 'top' },
      collision: { horizontal: 'fit', vertical: 'fit' }
    });
  }

  public hidePopup(): void {
    if (this.readmorePopup) {
      this.readmorePopup.close();
      this.readmorePopup = null;
    }
    event?.stopPropagation();
    event?.preventDefault();
  }
}
